import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/forgot-password')({
  component: lazyRouteComponent(() => import('&/features/forgot-password/pages/forgot-password-page')),
});
